import React from 'react';
import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { MenuItem, Select, OutlinedInput } from '@mui/material';
import styles from '../CompaniesPage.module.scss';
import moment from 'moment';

const orderByFilter = [
  { name: 'All', value: 'all' },
  { name: 'By update date', value: 'updated_at' },
  { name: 'By date', value: 'created_at' },
];

const OFI = [
  { name: 'All', value: 'all', query: 'all' },
  {
    name: 'Yes',
    query: {
      column: 'is_open_for_investment',
      filter: true,
    },
  },
  {
    name: 'No',
    query: {
      column: 'is_open_for_investment',
      filter: false,
    },
  },
];

const statusFilter = [
  { name: 'All', value: 'all', query: 'all' },
  {
    name: 'Is draft',
    value: 'is_draft',
    query: {
      column: 'is_draft',
      filter: true,
    },
  },
  {
    name: 'Active',
    value: 'active',
    query: {
      column: 'is_draft',
      filter: false,
    },
  },
];

const Filter = ({
  changeInvestment,
  changeStatus,
  changeOrder,
  searchCompany,
  inputValue,
  dateInputValue,
  searchByRegistrationDate,
}) => (
  <Box className={styles.filters}>
    <div className={styles.searchFilter}>
      <SearchIcon sx={{ color: '#555555' }} className={styles.searchFilterIcon} />
      <OutlinedInput
        value={inputValue}
        className={styles.searchFilterInput}
        placeholder="Search"
        onChange={(e) => searchCompany(e.target.value)}
      />
    </div>
    <Box className={styles.selects}>
      <Select
        displayEmpty
        defaultValue="created_at"
        onChange={(e) => changeOrder(e.target.value)}
        className={styles.filterSelect}
        renderValue={(selected) => {
          if (!selected) {
            return <p className={styles.filterSelectPlaceholder}>Sort by</p>;
          }
          return orderByFilter.find((item) => item.value === selected).name;
        }}
      >
        <MenuItem disabled value="">
          <Box className={styles.menuItem}>Sort by</Box>
        </MenuItem>
        {orderByFilter.map((item) => (
          <MenuItem value={item.value}>
            <Box className={styles.menuItem}>{item.name}</Box>
          </MenuItem>
        ))}
      </Select>
      <Select
        displayEmpty
        onChange={(e) => changeStatus(e.target.value)}
        className={styles.filterSelect}
        renderValue={(selected) => {
          if (!selected) {
            return <p className={styles.filterSelectPlaceholder}>Status</p>;
          }

          return statusFilter.find((item) => item.query.filter === selected.filter).name;
        }}
      >
        <MenuItem disabled value="">
          Status
        </MenuItem>
        {statusFilter.map((item) => (
          <MenuItem value={item.query}>
            <Box className={styles.menuItem}>{item.name}</Box>
          </MenuItem>
        ))}
      </Select>
      <Select
        displayEmpty
        onChange={(e) => changeInvestment(e.target.value)}
        className={styles.filterSelect}
        renderValue={(selected) => {
          if (!selected) {
            return <p className={styles.filterSelectPlaceholder}>OFI</p>;
          }
          return OFI.find((item) => item.query.filter === selected.filter).name;
        }}
      >
        <MenuItem disabled value="">
          <Box className={styles.menuItem}>OFI</Box>
        </MenuItem>
        {OFI.map((item) => (
          <MenuItem value={item.query}>
            <Box className={styles.menuItem}>{item.name}</Box>
          </MenuItem>
        ))}
      </Select>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DesktopDatePicker
          label="Date of registration"
          inputFormat="YYYY/MM"
          minDate={1970}
          disableFuture
          value={dateInputValue ? new Date(dateInputValue) : null}
          onChange={(e) => searchByRegistrationDate(moment(e).format('YYYY-MM-DD'))}
          className={styles.datePickerInput}
          slots={null}
        />
      </LocalizationProvider>
    </Box>
  </Box>
);

export default Filter;
